import {
  Component,
  OnInit,
  Input,
  ChangeDetectorRef,
  OnDestroy,
  AfterContentChecked,
} from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { Observable, Subject, Subscription } from 'rxjs';
import { DateRangeType, FormAction, LookupType } from '@shared-features/enums/shared-enums.enum';
import { ConfigConstant } from '@shared/constants';
import { Customer } from '@features/customers/models/customer.model';
import { FilterService } from '../../../filter/services/filter.service';
import { BaseComponent } from '@shared-features/components/base-component/base.component';
import { LocalStorageDashboardStatus } from '../../../dashboard/models';
import { LocalStorageUtil } from '@shared/utils';
import { StorageConstant } from '@shared/constants/storage.constant';
import { SharedAPI } from '@shared-features/services';

@Component({
  selector: 'app-organization-business-status',
  templateUrl: './organization-business-status.component.html',
  styleUrls: ['./organization-business-status.component.scss'],
})
export class OrganizationBusinessStatusFilterComponent
  extends BaseComponent
  implements OnInit, OnDestroy, AfterContentChecked
{
  @Input() action: Observable<void>;
  form: FormGroup;
  dispose$ = new Subject();

  sharedConstants = ConfigConstant;
  dateRangeType = DateRangeType;
  filterActionSubscription: Subscription;
  params: any = null;
  customers: Customer[] = [];
  currentURL: any;
  maxDate: Date = new Date();
  protected readonly LookupType = LookupType;

  dashboardStatus: LocalStorageDashboardStatus = new LocalStorageDashboardStatus();

  constructor(
    private filterService: FilterService,
    private ref: ChangeDetectorRef,
    private sharedAPI: SharedAPI
  ) {
    super();
  }

  ngOnInit(): void {
    this.getAllCustomers();
    this.dashboardStatus = LocalStorageUtil.getItem(StorageConstant.LOCAL_STORAGE_DASHBOARD_STATUS);
    this.subscribeToFilterAction();
    this.subscribeOnGeneralDashboardDateRange();
  }

  ngOnDestroy() {
    this.filterActionSubscription.unsubscribe();
  }

  ngAfterContentChecked() {
    this.ref.detectChanges();
  }

  getAllCustomers() {
    this.load(this.sharedAPI.getAllCustomers(), { isLoadingTransparent: true }).subscribe(
      (customers) => {
        this.customers = customers;
        this.initForm();
        this.ref.detectChanges();
      }
    );
  }

  subscribeOnGeneralDashboardDateRange() {
    this.filterService.generalDashboardDateRange$.subscribe((value) => {
      if (value && value !== DateRangeType.ALL_TIME) {
        this.dashboardStatus.orderStatusTime = value;
        this.form.controls['dateRange'].setValue(value);
        LocalStorageUtil.setItem(StorageConstant.DASHBOARD_ORDER_STATUS, this.dashboardStatus);
        this.submitForm();
      }
    });
  }

  initForm() {
    const filtersValue = LocalStorageUtil.getItem(StorageConstant.LOCAL_STORAGE_DASHBOARD_STATUS);

    this.form = new FormGroup({
      customerId: new FormControl(filtersValue?.customerId),
      dateRange: new FormControl(filtersValue?.dateRange),
    });

    if (this.dashboardStatus.businessUnitStatusOrganizationCustomerId) {
      const _customerId =
        this.dashboardStatus.businessUnitStatusOrganizationCustomerId === ConfigConstant.ALL
          ? ConfigConstant.ALL
          : Number(this.dashboardStatus.businessUnitStatusOrganizationCustomerId);
      this.form.controls['customerId'].setValue(_customerId);
    }

    if (this.dashboardStatus.businessUnitStatusOrganizationTime) {
      this.form.controls['dateRange'].setValue({
        range: this.dashboardStatus.businessUnitStatusOrganizationTime,
        startFrom: this.dashboardStatus.businessUnitStatusOrganizationCustomTimeFrom,
        endAt: this.dashboardStatus.businessUnitStatusOrganizationCustomTimeTo,
      });
    }
  }

  subscribeToFilterAction() {
    this.filterActionSubscription = this.action.subscribe((action: any) => {
      switch (action) {
        case FormAction.Reset:
          this.resetForm();
          break;

        case FormAction.Cancel:
          this.cancelChanges();
          break;

        case FormAction.Submit:
          this.submitForm();
          break;
      }
    });
  }

  resetForm() {
    this.form.controls['customerId'].setValue(ConfigConstant.ALL);
    this.form.controls['dateRange'].setValue({ range: DateRangeType.TODAY });
    this.submitForm();
  }

  cancelChanges() {
    const filtersValue = LocalStorageUtil.getItem(StorageConstant.LOCAL_STORAGE_DASHBOARD_STATUS);
    if (filtersValue) {
      this.form?.controls['customerId']?.setValue(filtersValue?.customerId);
      this.form?.controls['dateRange']?.setValue(filtersValue?.dateRange);
    } else this.resetForm();
  }

  submitForm() {
    LocalStorageUtil.setItem(StorageConstant.LOCAL_STORAGE_DASHBOARD_STATUS, this.form.value);
  }
}
